<app-youth-info-center-hero (scrollToId)="scrollToId($event)"></app-youth-info-center-hero>

<section class="youth-info-center-list">
  <app-search-engine [fields]="youthInfoCenterSearchEngineConfig" [displayAsOpenedModal]="true"></app-search-engine>

  <ng-container *ngIf="(hasSearched$ | async) === true">
    <ng-container *ngIf="(loading$ | async) === false; else skeleton">
      <ul class="youth-info-center-list__cards">
        <li
          *ngFor="let item of youthInfoCenters$ | async; let i = index; trackBy: trackByYouthInfoCenterId"
          class="youth-info-center-list__card"
        >
          <app-youth-info-center-card
            [youthInfoCenter]="item"
            [elmId]="focusBaseId + '-' + i"
          ></app-youth-info-center-card>
        </li>
      </ul>
    </ng-container>
  </ng-container>

  <app-pagination
    [hidden]="loading$ | async"
    [nbHits]="(nbYouthInfoCenters$ | async)!"
    [currentPageNumber]="(page$ | async)!"
  ></app-pagination>
</section>

<ng-template #skeleton>
  <div class="skltn__cards">
    <ngx-skeleton-loader
      class="skltn__card"
      [count]="3"
      animation="progress"
      [theme]="(isMobile$ | async) ? skltnCardMobile : skltnCard"
    ></ngx-skeleton-loader>
  </div>
</ng-template>

<section role="region" class="wrapper--bg">
  <ul class="youth-info-center-infos" [style.margin-top]="(hasSearched$ | async) === true ? '3.125rem' : '0rem'">
    <li>
      <app-info-block
        [id]="'mission-locale'"
        [infoBlockConfig]="localMissionBlockConfig"
        (tracker)="onTrackerInfoBlockClicked('Click Infos Jeunes')"
        [withExpansionPanel]="true"
      >
        <div class="youth-info-center-infos__text">
          <p>
            Les missions locales sont présentes sur l&apos;ensemble du territoire national et permettent à tous les
            jeunes de 16 à 25 ans de surmonter les difficultés qui font obstacle à leur insertion professionnelle et
            sociale.
          </p>
          <p>
            Avec un accompagnement global pour les jeunes, elles traitent l&apos;ensemble des difficultés
            d&apos;insertion: emploi, formation, orientation, mobilité, logement, santé, accès à la culture et aux
            loisirs.
          </p>
          <p>
            Les conseillers missions locales vont avoir comme mission de préparer les jeunes candidats à une offre
            d&apos;emploi, les aider à se maintenir dans l&apos;emploi (soutien matériel, médiation jeune-employeur) et
            proposent également un accompagnement post emploi.
          </p>
          <p>
            Au cours des entretiens, le conseiller aide le jeune à s&apos;orienter et examine avec lui les moyens à
            mobiliser pour lever les freins à l&apos;emploi.
          </p>
        </div>
      </app-info-block>
    </li>
    <li>
      <app-info-block
        [id]="'PIJ'"
        [infoBlockConfig]="infoYoungConfig"
        (tracker)="onTrackerInfoBlockClicked('Click Click Mission Locale')"
        [withExpansionPanel]="true"
      >
        <div class="youth-info-center-infos__text">
          <p>La structure Info Jeunes (SIJ) accueille tous les jeunes (de 12 à 30 ans) anonymement et gratuitement.</p>
          <p>
            Des professionnels sont là pour vous aider à trouver des informations et vous accompagner sur tous les
            sujets qui vous concernent ou vous intéressent ; qu&apos;il s&apos;agisse de scolarité, de formation,
            d&apos;emploi, de logement, de loisirs, de préparer un départ vers l&apos;étranger, ou encore de monter un
            projet pour lequel des aides sont disponibles…
          </p>
          <p>
            De la documentation, des revues, des ordinateurs etc. sont disponibles en libre accès et la SIJ propose
            également un soutien pour l&apos;élaboration de CV, la rédaction des lettres de motivation ou encore la
            préparation aux entretiens de recrutement.
          </p>
        </div>
      </app-info-block>
    </li>
  </ul>
</section>
